import React, { useEffect } from "react";
import { NodeProps, useUpdateNodeInternals } from "@xyflow/react";
import { PhoneIncoming } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useFlowBuilder } from "../components/FlowBuilderContext";
import { BranchHandle } from "./BranchHandles";

export default function StartNode({ id }: NodeProps) {
  const updateNodeInternals = useUpdateNodeInternals();
  const { orientation } = useFlowBuilder();
  const isHorizontal = orientation === "horizontal";

  useEffect(() => {
    updateNodeInternals(id);
  }, [id, isHorizontal, updateNodeInternals]);

  return (
    <Card className="nopan relative w-[340px] shadow-none">
      <div className="flex items-center gap-3 px-4 py-4">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
          <PhoneIncoming className="h-5 w-5" />
        </div>
        <div className="min-w-0">
          <div className="text-base font-semibold">Incoming call</div>
          <div className="text-sm text-muted-foreground">When a call comes in, what should happen first?</div>
        </div>
      </div>

      <div className="border-t">
        <BranchHandle nodeId={id} isHorizontal={isHorizontal} />
      </div>
    </Card>
  );
}
